module.exports = __webpack_public_path__ + "img/32.29e374b6.jpg";